import React from 'react';
import { useQuery } from '@tanstack/react-query';
import axiosClient from '../../api/axiosClient';

const CmsPageView = ({ slug }) => {
  const { data: page, isLoading, isError } = useQuery({
    queryKey: ['publicPage', slug],
    queryFn: async () => {
      const res = await axiosClient.get(`/public/pages/${slug}`);
      
      return res; 
    },
    retry: false // Don't retry if 404
  });

  // Loading State
  if (isLoading) return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="text-slate-500 animate-pulse">Loading Content...</div>
    </div>
  );

  // Error/404 State (Dark Mode)
  if (isError || !page) return (
    <div className="min-h-screen bg-[#020617] flex flex-col items-center justify-center p-8 text-center">
        <h2 className="text-3xl font-black text-slate-800 mb-2">404</h2>
        <p className="text-slate-500">Page Not Found or Unpublished.</p>
        <p className="text-xs text-slate-700 mt-4 max-w-md">
            Admin Note: Ensure a page with slug <span className="font-mono text-teal-500">"{slug}"</span> exists and is published in "Pages & Legal".
        </p>
    </div>
  );

  // Content State
  return (
    <div className="bg-[#020617] min-h-screen py-20 px-6 sm:px-12 animate-in fade-in duration-500">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-black text-white mb-10 tracking-tight border-b border-slate-800 pb-8">
            {page.title}
        </h1>
        
        {/* Prose Invert makes the HTML white/light-gray for dark backgrounds */}
        <div 
          className="prose prose-lg prose-invert max-w-none 
            prose-headings:text-white prose-p:text-slate-300 prose-strong:text-white 
            prose-a:text-teal-400 prose-ul:text-slate-300"
          dangerouslySetInnerHTML={{ __html: page.content || page.content_html }} 
          
        />
        
        <div className="mt-16 pt-8 border-t border-slate-800 text-xs text-slate-600 font-mono">
            Last Updated: {new Date(page.updated_at).toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default CmsPageView;